<div class="row page-header">
    <div class="col-12">
        <h1>Fuel Entry <small>Log the transers of fuels</small></h1>
    </div>
</div>
<div class="container-sm" style="max-width: 800px; padding: 0" [hidden]="isInitialLoading">
    <form [hidden]="saved">
        <div>
            <div class="col-12">
                <div class="row">
                    <div class="col">
                        <div class="wj-labeled-input">
                            <wj-auto-complete
                                id="source"
                                [displayMemberPath]="'display'"
                                [itemsSource]="fuelSourceOptions"
                                [selectedValuePath]="'value'"
                                [maxItems]="100"
                                [(selectedValue)]="source"
                                name="source"
                                [isRequired]="false"
                                [isEditable]="false"
                            >
                            </wj-auto-complete>
                            <label for="source">Fuel <b>OUT</b></label>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="wj-labeled-input">
                            <wj-input-number
                                id="lifetimeMeter"
                                [min]="0"
                                [isRequired]="true"
                                [format]="'n1'"
                                [step]="1"
                                [(value)]="lifetimeMeter"
                            ></wj-input-number>
                            <label for="lifetimeMeter">Lifetime Meter Reading</label>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="wj-labeled-input">
                            <wj-auto-complete
                                id="source"
                                [displayMemberPath]="'display'"
                                [itemsSource]="lifetimeMeterIdOptions"
                                [selectedValuePath]="'value'"
                                [(selectedValue)]="lifetimeMeterId"
                                name="lifetimeMeterId"
                                [isRequired]="false"
                                [isEditable]="false"
                            >
                            </wj-auto-complete>
                            <label for="lifetimeMeterId">Lifetime Meter Id</label>
                        </div>
                    </div>
                </div>
                <div class="row" style="margin-bottom: 30px">
                    <div class="col-md-6 col-sm-12" style="margin-bottom: 10px">
                        <button mat-raised-button (click)="reset()">Reset</button>
                    </div>
                    <div class="col-md-6 col-sm-12" style="margin-bottom: 10px">
                        <button mat-raised-button [disabled]="!source" (click)="save()">
                            @if (isSaving) {
                                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
                            } @else {
                                <span>Save</span>
                            }
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div [hidden]="!saved">
        <div>
            <div class="col-lg-6 col-md-12 col-sm-12 saved">
                <div style="text-transform: uppercase">The entry has been saved</div>
                <table class="results-table">
                    <tr>
                        <td>Source:</td>
                        <td>{{ source }}</td>
                    </tr>
                    <tr>
                        <td>Lifetime Meter:</td>
                        <td>{{ lifetimeMeter }}</td>
                    </tr>
                    <tr>
                        <td>Lifetime Meter Id:</td>
                        <td>{{ lifetimeMeterId }}</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 saved">
                <button mat-raised-button color="primary" (click)="reset()">Log Another</button>
            </div>
        </div>
    </div>
</div>
